import { clsx, type ClassValue } from "clsx"
import { twMerge } from "tailwind-merge"

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs))
}

export function getAvatarColor(seed: string) {
  let hash = 0;
  for (let i = 0; i < seed.length; i++) {
    hash = seed.charCodeAt(i) + ((hash << 5) - hash);
  }

  // Use a fixed range for "lite" colors
  // Hue: 0-360
  // Saturation: 70-80% for vibrancy
  // Lightness: 85-95% for "lite" appearance
  const hue = Math.abs(hash % 360);
  const saturation = 75;
  const lightness = 90;

  return `hsl(${hue}, ${saturation}%, ${lightness}%)`;
}
